import { RolloutListItemFragment } from '@spotify/confidence-graphql';
import { MetricsData } from '@spotify/plugin-confidence-metrics';
import { getIsEditDisabled } from '@spotify/plugin-confidence-workflows';

export const isEditDisabled = getIsEditDisabled(['ended', 'archived']);

export const isEditAllocationDisabled = (
  instance?: Maybe<{ state: string }>,
) => {
  return (
    instance?.state?.includes('ended') || instance?.state?.includes('archived')
  );
};

export const tabForState = (workflowInstance: RolloutListItemFragment) => {
  const { state, stateHistory } = workflowInstance;
  const wasLive = stateHistory?.some(e => e.state === 'live');
  const isLive = state === 'live';

  if (state === 'draft' || (!wasLive && !isLive)) {
    return 'design';
  }

  return 'result';
};

const inferVariantDisplayName = (name: string) =>
  name.split('/').at(-1) ?? 'untitled-variant';

export const inferFlagNameFromVariant = (name: string) => {
  return name.replace(`/variants/${inferVariantDisplayName(name)}`, '');
};

export const getCalculateSampleSizeDisabledReason = (
  flag?: string,
  metricsData?: MetricsData,
) => {
  if (!flag) {
    return 'You must select a flag and variant before calculating the required sample size';
  }

  if (!metricsData?.metrics.some(m => !m.surfaceOnly)) {
    return 'You must add at least one non-required metric to the rollout before calculating the required sample size';
  }
  return undefined;
};
